import {
  Box,
  Button,
  Center,
  Flex,
  Image,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import React from "react";
import { Settings, User } from "react-feather";
import { useLocation, useNavigate } from "react-router-dom";
import { Context } from "../ContextWrapper";
import NotificationContainer from "./generic/updateNotification";

export default function Navigation({ isAdmin }) {
  const context = React.useContext(Context);
  const navigate = useNavigate();
  const location = useLocation();

  const clientPathMatch = location.pathname.match(/^\/client\/([^/]+)(?:\/.*)?$/);
  const activeClientId = clientPathMatch ? clientPathMatch[1] : null;

  return (
    <>
      <Box
        bg="brand.1000"
        color="white"
        px={4}
        position="fixed"
        top="0"
        left="0"
        w="100%"
        zIndex="1000"
      >
        <Box position="absolute" top="0" left="0" w="100%" zIndex="1001">
          <NotificationContainer />
        </Box>
        <Flex h="80px" alignItems="center" justifyContent="space-between">
          <Center w={280}>
            <Box>
              <Image
                onClick={() => navigate("/")}
                boxSize="170px"
                objectFit="contain"
                src="/lucro-logo-white.png"
                cursor="pointer"
                height={"80px"}
              />
            </Box>
          </Center>
          <Flex alignItems="center">
            {/* Menus */}
            {isAdmin && (
              <Menu>
                <MenuButton
                  as={Button}
                  rounded="full"
                  variant="link"
                  cursor="pointer"
                  minW={0}
                >
                  <Settings color="white" />
                </MenuButton>
                <MenuList zIndex={99999}>
                  <MenuItem onClick={() => navigate("/account-management")}>
                    Accounts
                  </MenuItem>
                  <MenuItem onClick={() => navigate("/admin-tools")}>
                    Admin Tools
                  </MenuItem>
                  <MenuItem
                    onClick={() => navigate("/chart-of-accounts-template")}
                  >
                    CoA
                  </MenuItem>
                  {activeClientId && (
                    <MenuItem
                      onClick={() => {
                        // Persist the selected client so dashboard pages pick it up (like Vendor Analysis / Bank Activity fallback)
                        sessionStorage.setItem("selectedCustomerId", activeClientId);
                        window.dispatchEvent(new Event("selectedCustomerId-changed"));
                        navigate("/growth-plan");
                      }}
                    >
                      Client Dashboard
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={() => navigate("/management/accounts")}
                  >
                    Management Dashboard
                  </MenuItem>
                  <MenuItem
                    onClick={() => navigate("/quality-control-reviews")}
                  >
                    Quality Control
                  </MenuItem>
                  <MenuItem onClick={() => navigate("/users")}>Users</MenuItem>
                  <MenuItem onClick={() => navigate("/vendors")}>
                    Vendors
                  </MenuItem>
                </MenuList>
              </Menu>
            )}
            <Menu>
              <MenuButton
                as={Button}
                rounded="full"
                variant="link"
                cursor="pointer"
                minW={0}
                pl="20px"
              >
                <User color="white" />
              </MenuButton>
              <MenuList zIndex={99999}>
                <MenuItem
                  onClick={() =>
                    context.fireToast(
                      "Profile settings",
                      "Under construction, Coming soon....",
                      "success"
                    )
                  }
                >
                  Profile Settings
                </MenuItem>
                <MenuDivider />
                <MenuItem onClick={() => navigate("/logout")}>Logout</MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Flex>
      </Box>
    </>
  );
}
